<svelte:head>

    <link rel='stylesheet' href='/global.css' />
    <link rel="stylesheet" type="text/css" href="css/charts.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { getContext } from "svelte";

    import {
        getLocalPropertyId
    } from "../utils/session";

    import {
        chartOptions,
        loadMainChartData,
        loadSpecialOrFilteredChartData,
        tooltipFormatter
    } from "../utils/charts";

    import {
        isDatesDefault,
        isDisplayDefault,
        isFilterDefault
    } from "./utils/filter";

    import highcharts from "../utils/highcharts";
    import highchartsmap from "../utils/highchartsmap";
    import worldMap from "@highcharts/map-collection/custom/world.geo.json";

    import Filter from "./utils/filter.svelte";
    import Header from "./header.svelte";
    import { ageIdentifiers } from "../utils/general";


    const router = getContext('router');


    let showInfo = false;
    let earliest;
    let filterData = JSON.parse(JSON.stringify(chartOptions));
    let chartConfigs = {
        'gender': false,
        'vip': false,
        'age': false,
        'tags': false,
        'origins': false
    };
    let data;
    let tempData;

    let tripadvisorProfileUrl = 'https://tripadvisor.com/Profile/';

    let ageGroups = ['13-17', '18-24', '25-34', '35-49', '50-64', '65+'];

    onMount(() => {

        assembleChartData();
    });

    let assembleChartData = (filtered = false, isDates = false) => {

        let chartId = 'guests_audience';
        let chartType = 'chart';

        let propertyId = getLocalPropertyId();

        if (filtered || isDates) {

            if (filterData['dates']['start'] === 0) {

                filterData['dates']['start'] = earliest;
            }

            loadSpecialOrFilteredChartData(router, false, chartId, chartType, propertyId, filterData).then((chartData) => {

                data['data']['data'] = chartData['data'];
                data['data']['total'] = chartData['total'];

                handleDataGuests();

            });

        } else {

            if (earliest) {

                if (filterData['dates']['start'] === 0) {

                    filterData['dates']['start'] = earliest;
                }

            }

            loadMainChartData(router, false, chartId, chartType, propertyId, filterData).then((chartData) => {

                data = chartData;

                if (!earliest) {

                    earliest = chartData['settings']['meta']['earliest'];
                }

                handleDataGuests();

            });

        }

    };

    let receiveDateOptions = (data) => {

        filterData['dates'] = data.detail;

        let isDates = true;
        let filtered = true;

        if (isDatesDefault(filterData['dates'], earliest)) {

            isDates = false;
        }
        if (isFilterDefault(filterData['filter'])) {

            filtered = false;
        }

        assembleChartData(filtered, isDates);

    };

    let handleDataGuests = () => {

        chartConfigs = {};

        let chartSpecialties = setupGuestsAgeOriginChartData();

        chartConfigs['gender'] = {

            chart: {
                type: 'pie',
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                borderRadius: 0,
                margin: [0, 0, 0, 0],
                spacingTop: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0,
                style: {
                    fontFamily: 'Roboto',
                    fontWeight: 600
                }
            },
            title: {
                verticalAlign: 'middle',
                floating: true,
                text: data['data']['total'],
                /*y: 15,*/
                style: {
                    fontSize: window.innerHeight * 0.028 + 'px'
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            xAxis: {
                minPadding: 0,
                maxPadding: 0
            },
            yAxis: {
                minPadding: 0,
                maxPadding: 0
            },
            plotOptions: {
                pie: {
                    size: window.innerHeight * 0.137,
                    dataLabels: {
                        enabled: false
                    },
                    borderWidth: 3
                },
                series: {
                    states: {
                        hover: {
                            halo: null
                        }
                    }
                }
            },
            series: [
                {
                    innerSize: '60%',
                    data: [
                        {
                            y: data['data']['data']['gender']['fem']['num'],
                            color: {
                                linearGradient: {
                                    x1: 0, x2: 1, y1: 0, y2: 1
                                },
                                stops: [
                                    [0, '#FF3782'],
                                    [1, '#FF37CA']
                                ]
                            }
                        },
                        {
                            y: data['data']['data']['gender']['mal']['num'],
                            color: {
                                linearGradient: {
                                    x1: 0, x2: 1, y1: 0, y2: 1
                                },
                                stops: [
                                    [0, '#19CEDB'],
                                    [1, '#16A7E8']
                                ]
                            }
                        }
                    ]
                }
            ]
        };

        chartConfigs['age'] = {

            chart: {
                type: 'bar',
                /*margin: [0, 0, 0, 0],*/
                spacingTop: 0,
                spacingBottom: 0,
                /*spacingLeft: 0,*/
                spacingRight: 15
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            xAxis: {
                allowDecimals: false,
                categories: chartSpecialties['age']['categories'],
                lineWidth: 0,
                /*tickWidth: 0,*/
                labels: {
                    step: 1,
                    style: {
                        fontFamily: 'Raleway',
                        fontSize: '1.3vh',
                        color: '#383874'
                    }
                },
                minPadding: 0.005,
                maxPadding: 0.005,

                /*dataLabels: {
                    enabled: true
                }*/
            },
            yAxis: {
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                lineWidth: 0,
                tickWidth: 0,
                minPadding: 0.005,
                maxPadding: 0.005,
                visible: false
            },
            plotOptions: {
                bar: {
                    stacking: 'normal',
                    borderRadius: '0.44vh',
                    pointWidth: window.innerHeight * 0.015
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    }
                }
            },
            series: [
                {
                    name: 'fem',
                    data: chartSpecialties['age']['fem'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: [
                            [0, '#FF3782'],
                            [1, '#FF37CA']
                        ]
                    },
                    pctData: chartSpecialties['age']['pct'],
                    dataLabels: {
                        enabled: true,
                        inside: false,
                        formatter: function() {
                            return this.series.userOptions.pctData[this.point.index] + '%';
                        },
                        crop: false,
                        overflow: 'none',
                        style: {
                            textOutline: 0,
                            color: 'rgba(56, 56, 116, 0.6)',
                            fontFamily: 'Roboto',
                            fontWeight: 500,
                            fontSize: '1.1vh'
                        }
                    }
                },
                {
                    name: 'mal',
                    data: chartSpecialties['age']['mal'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: [
                            [0, '#19CEDB'],
                            [1, '#16A7E8']
                        ]
                    },
                    dataLabels: {
                        enabled: false
                    },
                },
                /*{
                    name: 'pct',
                    /!*visible: false,*!/
                    data: chartDataAge['pct'],
                    dataLabels: {
                        enabled: true
                    }
                }*/
            ]
        };

        chartConfigs['origin'] = {

            'config': {

                chart: {
                    map: worldMap,
                    resetZoomButton: {
                        theme: {
                            display: 'none'
                        }
                    },
                    margin: [0, 0, 0, 0],
                    type: 'map'
                },
                title: {
                    text: null
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    useHTML: true,
                    backgroundColor: null,
                    borderWidth: 0,
                    shadow: false,
                    shared: false,
                    formatter: tooltipFormatter
                },
                colorAxis: {
                    min: 0,
                    minColor: '#a0c7ff',
                    maxColor: '#00415f'
                },
                mapNavigation: {
                    enabled: true,
                    enableButtons: false
                },
                plotOptions: {
                    series: {
                        borderColor: '#f6f6f6'
                    }
                },
                series: [{
                    name: 'origins',
                    data: Array.from(chartSpecialties['origin'])
                }]

            },
            'zoom': 0

        };

    };

    let setupGuestsAgeOriginChartData = () => {

        let chartData = {
            'age': {
                'categories': [],
                'fem': [],
                'mal': [],
                'pct': []
            },
            'origin': []
        };

        for (const ageKey of ageGroups) {

            chartData['age']['categories'].push(ageIdentifiers[ageKey]);

            if (!(ageKey in data['data']['data']['age'])) {

                chartData['age']['fem'].push(0);
                chartData['age']['mal'].push(0);
                chartData['age']['pct'].push(0);

            } else {

                chartData['age']['fem'].push(data['data']['data']['age'][ageKey]['fem']);
                chartData['age']['mal'].push(data['data']['data']['age'][ageKey]['mal']);
                chartData['age']['pct'].push(data['data']['data']['age'][ageKey]['pct']);

            }

        }

        for (const mapPoint of data['data']['data']['origins']) {

            if (mapPoint['num'] !== 0) {

                chartData['origin'].push([
                    mapPoint['country'].toLowerCase(),
                    mapPoint['num']
                ]);

            }

        }

        return chartData;

    };

    let receiveChartOptions = (data) => {

        filterData['filter'] = data.detail['map']['filter'];
        filterData['display'] = data.detail['map']['display'];

        let filtered;
        let isDates = false;

        if (!isFilterDefault(filterData['filter'])) {

            filtered = true;
        }

        if (!isDatesDefault(filterData['dates'], earliest)) {

            isDates = true;
        }

       assembleChartData(filtered, isDates);

    };

    let changeMapZoom = (zoom) => {

        chartConfigs['origin']['zoom'] = zoom;
    };

</script>

<Header
        startDate={earliest}
        on:dates={receiveDateOptions}
        on:propertychange={() => assembleChartData(false, false)}
        keyword={false}
/>

{#if data}

    <Filter
            data={data}
            on:filtersMenu={receiveChartOptions}
    />

{/if}

<section>

    {#if data}

        <div class="main">

            <div id="chart-container">

                <h1 class="chart-title">
                    <span class="title">Zielgruppe</span>
                    <span class="info show" on:click={() => showInfo = !showInfo}><img src="images/icon-info.svg" alt="Chart Info"></span>
                </h1>

                <div id="chartarea">

                    <div class="area-column">

                        <div id="area-gender" class="area-item">

                            <div class="chart-header">

                                <div class="chart-title">Geschlecht</div>

                            </div>

                            <div id="gender-container">

                                <div class="nodata" class:show={!data['data']['data']['gender']['fem']['num'] && !data['data']['data']['gender']['mal']['num']}>Keine Daten verfügbar.</div>
                                
                                {#if data['data']['data']['gender']['fem']['num'] || data['data']['data']['gender']['mal']['num']}

                                    <div id="gender-chart" use:highcharts={chartConfigs['gender']}></div>

                                    <div id="gender-legend">

                                        <div class="legend-item" data-legend="fem">

                                            <div class="legend-label">FRAUEN</div>

                                            <div class="legend-stats">

                                                <img src="images/icon-legend-fem.svg" class="legend-bullet" />
                                                <div class="legend-num">{data['data']['data']['gender']['fem']['pct']}%</div>

                                            </div>

                                        </div>

                                        <div class="legend-item" data-legend="mal">

                                            <div class="legend-label">MÄNNER</div>

                                            <div class="legend-stats">

                                                <img src="images/icon-legend-mal.svg" class="legend-bullet" />
                                                <div class="legend-num">{data['data']['data']['gender']['mal']['pct']}%</div>

                                            </div>

                                        </div>

                                    </div>

                                {/if}

                            </div>

                        </div>

                        <div id="area-vip" class="area-item">

                            <div class="chart-header">

                                <div class="chart-title">Erfahrenste Gäste</div>

                            </div>

                            {#if data['data']['data']['vip'].length !== 0}

                                <div id="vip-container">

                                    {#each Object.entries(data['data']['data']['vip']) as [vipKey, vip], index(vipKey)}

                                        <a href="{tripadvisorProfileUrl + vip['username']}" target="_blank">{vip['username']}</a>

                                    {/each}

                                </div>

                            {:else}

                                <div class="nodata show">Keine Daten verfügbar.</div>

                            {/if}

                        </div>

                    </div>

                    <div class="area-column">

                        <div id="area-age" class="area-item">

                            <div class="chart-header">

                                <div class="chart-title">Alter</div>

                            </div>

                            <div class="nodata">Keine Daten verfügbar.</div>

                            <div id="age-container">

                                <div id="age-chart" use:highcharts={chartConfigs['age']}></div>

                            </div>

                        </div>

                        <div id="area-tags" class="area-item">

                            <div class="chart-header">

                                <div class="chart-title">Interessen</div>

                            </div>

                            <div id="tags-container">

                            {#if Object.keys(data['data']['data']['tags']).length > 0}

                                {#each Object.entries(data['data']['data']['tags']) as [tagKey, tag], index(tagKey)}

                                    <div class="tag-item">

                                        <div class="tag-label">{tagKey}</div>
                                        <div class="tag-num">{tag}</div>

                                    </div>

                                {/each}

                                {:else}

                                    <div class="nodata show">Keine Daten verfügbar.</div>

                                {/if}

                            </div>


                        </div>

                    </div>

                    <div class="area-row">

                        <div id="area-origin" class="area-item">

                            <div class="chart-header">

                                <div class="chart-title">Herkunft</div>

                                <div id="origin-tools">

                                    <div class="btn-group">

                                        <img
                                                src="/images/icon-zoom-out.svg"
                                                id="map-zoomout"
                                                on:click={() => changeMapZoom('zoomout')}>

                                        <img
                                                src="/images/icon-zoom-in.svg"
                                                id="map-zoomin"
                                                on:click={() => changeMapZoom('zoomin')}>

                                    </div>

                                </div>

                            </div>

                            <div class="nodata">Keine Daten verfügbar.</div>

                            <div id="origin-container" use:highchartsmap={chartConfigs['origin']}></div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    {/if}

    <div class="chart-info" class:show={showInfo}>

        <div class="close">
            <img src="images/icon-close.svg" alt="Close" on:click={() => showInfo = !showInfo}/>
        </div>

        <div class="title">Zielgruppen</div>

        <div class="notice">


            Mit Alter, Geschlecht, Interessen und Herkunft fasst keyosh Ihre Zielgruppe von TripAdvisor Bewertungen zusammen.

        </div>

    </div>

</section>

<style>

    #chartarea {
        display: flex;
        flex-direction: row;
        height: 53vh;
        margin-top: 7vh;
    }

    .area-column {
        display: flex;
        flex-direction: column;
        margin-right: 3vh;
    }

    .area-row {
        display: flex;
        flex-direction: row;
    }

    /*.area-column:last-child {
        margin-right: 0;
    }*/

    .area-item {
        position: relative;
        flex-grow: 1;
        width: calc(100% - 5.33vh);
        padding: 1.87vh 2.67vh;
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        -webkit-box-shadow: 0px 40px 40px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 40px 40px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 40px 40px 0px rgba(73, 119, 172, 0.15);
    }

    .area-item .chart-title {
        margin-bottom: 0.36vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 300;
        font-size: 1.87vh;
    }

    #gender-container {
        margin: 0;
    }
    #gender-legend {
        width: 70%;
        margin: 0;
    }

    #area-gender, #area-age {
        margin-bottom: 3vh;
    }

    #area-gender {
        width: 22.5vh;
        max-height: 31.5vh;
    }

    #chartarea #gender-chart {
        width: 17.1vh;
        height: 17.1vh;
        margin-top: 3.14vh;
        margin-bottom: 3.42vh;
    }

    #vip-container {
        display: flex;
        flex-direction: column;
        margin-top: 2.31vh;
    }

    #vip-container a {
        margin-bottom: 1.6vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 500;
        font-size: 1.3vh;
        color: #383874;
    }

    #vip-container a:last-child {
        margin-bottom: 0;
    }

    #area-age {
        display: flex;
        flex-direction: column;
        max-height: 27vh;
    }

    #age-container {
        height: 100%;
        height: 100%;
        margin-top: 2.8vh;
        width: unset;
    }

    #age-chart {
        width: 35.3vh;
        /*min-height: 21.2vh;*/
        height: 100%;
        /*height: 21.2vh;*/
    }

    #area-tags {
        flex-shrink: 1;
        flex-grow: unset;
    }

    #tags-container {
        display: flex;
        flex-direction: column;
        min-height: 4vh;
        margin-top: 1.85vh;
        color: #383874;
    }

    #tags-container .tag-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 1.6vh;
        font-size: 1.3vh;
    }

    #tags-container .tag-item:last-child {
        margin-bottom: 0;
    }

    .tag-item .tag-label {
        font-family: 'Raleway', sans-serif;
    }

    .tag-item .tag-num {
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
    }

    #area-origin {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding: 0;
    }

    #area-origin .chart-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 1.87vh 2.67vh 1.6vh 2.67vh;
    }

    #area-origin .chart-header .chart-title {
        margin-bottom: 0;
    }

    #origin-tools {
        display: flex;
        flex-direction: row;
    }

    #origin-tools .btn-group {
        display: flex;
        flex-direction: row;
        background-color: #FFFFFF;
        border-radius: 1.01vh;
        -webkit-box-shadow: 0px 3px 6px 0px rgba(159, 159, 159, 0.25);
        -moz-box-shadow: 0px 3px 6px 0px rgba(159, 159, 159, 0.25);
        box-shadow: 0px 3px 6px 0px rgba(159, 159, 159, 0.25);
    }

    img#map-gps {
        width: 1.41vh;
        height: 1.41vh;
        padding: 0.73vh 0.85vh;
    }

    img#map-zoomout {
        width: 0.87vh;
        padding: 1.34vh 0.95vh 1.34vh 1.1vh;
    }

    img#map-zoomin {
        width: 1.12vh;
        height: 1.18vh;
        padding: 0.85vh 0.95vh;
    }

    #chartarea #origin-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        width: 40vh;
        height: 100%;
        /*margin-top: 2vh;*/
        border-radius: 1.39vh;
    }
</style>